module.exports = __webpack_public_path__ + "static/b1fa143cff563149ee0df097eb0b12ac.svg";